export const RequestMethods = {
    ETH_REQUEST_ACCOUNTS: 'eth_requestAccounts',
    WALLET_REVOKE_PERMISSIONS: 'wallet_revokePermissions',
    WALLET_SWITCH_ETHEREUM_CHAIN: 'wallet_switchEthereumChain',
    ETH_GET_BALANCE: 'eth_getBalance',
    ETH_ACCOUNTS: 'eth_accounts',
};
//# sourceMappingURL=request.js.map